import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useState, useActions } = createNamespacedHelpers('brand');
export const useBrand = () => {
    const { details } = useState(['details']);
    const { fetchBrandPlaceDetails } = useActions(['fetchBrandPlaceDetails']);
    return { brand: details, fetchBrandPlaceDetails };
};
